"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ComplianceAssurance() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const items = [{
    title: "Strategic Tax Alignment",
    content: "Navigating the complexities of cross-border taxation requires more than just filing returns. We align your fiscal residency with your corporate structure to ensure efficiency, transparency, and full compliance with international standards, including CRS and FATCA protocols."
  }, {
    title: "Legal Sustainability & Resilience",
    content: "A robust international strategy must be future-proof. We design legal frameworks that anticipate regulatory shifts, protecting your assets and residency status against geopolitical volatility and legislative changes. Our approach prioritizes long-term stability over short-term gains."
  }, {
    title: "Multi-Jurisdictional Rigor",
    content: "True freedom requires precise coordination. We synchronize your immigration status, corporate entities, and banking relationships across multiple jurisdictions. This eliminates friction and ensures that every layer of your international life is legally sound and operationally seamless."
  }];
  return;
}